import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { Fragment, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { AttractSpeakers } from '@/components/OrganiseEvent/AttractSpeakers';
import { CiteExample } from '@/components/OrganiseEvent/CiteExample';
import { CustomizeNeeds } from '@/components/OrganiseEvent/CustomizeNeeds';
import { EventExample } from '@/components/OrganiseEvent/EventExample';
import { GlobalAudience } from '@/components/OrganiseEvent/GlobalAudience';
import { GradientCallToAction } from '@/components/OrganiseEvent/GradientCallToAction';
import { Header } from '@/components/OrganiseEvent/Header';
import { PostEventEngagement } from '@/components/OrganiseEvent/PostEventEngagement';
import { Stack } from '@/components/OrganiseEvent/shared';
import { TopConferences } from '@/components/OrganiseEvent/TopConferences';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { useAnalytics } from '@/context/Analytics';

const OrganiseEvent = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const analytics = useAnalytics();
  const eventExampleElement = useRef();

  const onContactUs = (buttonText: string) => {
    return () => {
      analytics.track('contact_us_click', { button_text: buttonText });
      router.push('/contact-us/conferences').then(() => window.scrollTo(0, 0));
    };
  };

  const onLearnMore = () => {
    // @ts-ignore: Object is possibly 'null'.
    eventExampleElement.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Fragment>
      <NextSeo
        title="Organise an Event"
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}`,
        }}
      />
      <Layout>
        <Header onLearnMoreClick={onLearnMore} />
        <Stack>
          <EventExample ref={eventExampleElement} />
          <TopConferences />
          <CustomizeNeeds />
          <GradientCallToAction
            title={t('landing.pricingTitle')}
            subtitle={t('landing.pricingSubtitle')}
            action={t('landing.getInTouch')}
            onActionClick={onContactUs('Get in touch')}
          />
          <GlobalAudience />
          <AttractSpeakers />
          <GradientCallToAction
            title={t('landing.venueTitle')}
            subtitle={t('landing.venueSubtitle')}
            action={t('landing.getInTouch')}
            color="#B6FFE2"
            onActionClick={onContactUs('Get in touch')}
          />
          <PostEventEngagement />
          <CiteExample />
          <GradientCallToAction
            title={t('landing.impactfulTitle')}
            subtitle={t('landing.impactfulSubtitle')}
            action={t('landing.getInTouch')}
            onActionClick={onContactUs('Get in touch')}
          />
        </Stack>
      </Layout>
    </Fragment>
  );
};

export default OrganiseEvent;
